import {createRoot, hydrateRoot} from 'react-dom/client';
import AboutWhyUs from '../pages/AboutWhyUs/AboutWhyUs'
import "../index.css";
import "../pages/AboutWhyUs/AboutWhyUs.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<AboutWhyUs {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <AboutWhyUs {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).AboutWhyUsVC = {mount, hydrate, unmount}